<div class="mt-4">
  <div class="row">
    <div class="col-md-8 w-100 mt-3">
      <h4 class="title"><i class="fas fa-building"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-4 mt-3 content-position-end">
      <button type="button"
              class="btn btn-outline-success mw-180  custom-button font-weight-bold"
              *ngIf="hasAuthority('own:enterprise:add')"
              (click)="openAddModal()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
  <div>
    <div class="form-inline row">
      <div class="col-md-2 m-right custom-col-md-2" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label class="font-weight-bold text-end">{{ "LABEL.PARTNER" | translate }}:</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
          </div>
          <select *ngIf="hasRole(ROLE_SUPERADMIN)"
                  class="form-control ml-1"
                  [(ngModel)]="partnerSelected"
                  (ngModelChange)="reloadEnterprises()">
            <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col">
        <label class="font-weight-bold">{{ "LABEL.ENTERPRISE-NAME" | translate }}/RUC: </label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-keyboard" aria-hidden="true"></i></div>
          </div>
          <input type="text"
                 id="searchInput"
                 class="form-control ml-1"
                 placeholder="{{ 'MESSAGE.ENTER-TO-SEARCH' | translate }}"
                 [(ngModel)]="term2Search"
                 (keyup.enter)="reloadEnterprises()">
        </div>
      </div>
      <div class="col-md-1 m-top">
        <button type="button"
                class="btn btn-outline-success custom-button btn-width-100"
                [disabled]="term2Search === undefined"
                (click)="reloadEnterprises()">
          <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
        </button>
      </div>
      <div class="col m-top m-right m-left">
        <div class="custom-control custom-checkbox"
             *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
          <input type="checkbox"
                 id="onlyCustomersCheckbox"
                 class="custom-control-input input-custom-fixed"
                 [(ngModel)]="isCustomer"
                 (click)="onlyCustomersClic($event)">
          <span class="custom-control-label font-weight-bold text-start">{{ "LABEL.ONLY-CLIENTS" | translate }}</span>
        </div>
      </div>
    </div>
    <div class="mt-2 table-responsive custom-table-height ">
      <table class="table-sm table-bordered">
        <thead>
        <tr class="bg-success">
          <th scope="col" title="#"></th>
          <th scope="col" title="{{'TABLE.HEADER.TYPE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.DOCUMENT-TYPE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.DOCUMENT-NUMBER' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.ENTERPRISE-NAME' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.BALANCE-IOF' | translate }}"
              *ngIf="showBalanceInfo && hasConfigBalance"></th>
          <th scope="col" title="{{'TABLE.HEADER.STORAGE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.DATE-AT' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.STATE' | translate }}"></th>
          <th scope="col" title="{{'TABLE.HEADER.ACTION' | translate }}"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let enterprise of enterprises; let index=index">
          <td title="#"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
          <td title="{{'TABLE.HEADER.TYPE' | translate }}">
                <span class="{{isOnlyEnterprise(enterprise)?'badge badge-secondary':
                isntPartner(enterprise)?'':'badge badge-success'}}">{{isOnlyEnterprise(enterprise) ? 'Cliente' : isntPartner(enterprise) ? '-' : 'Partner'}}</span>
          </td>
          <td title="{{'TABLE.HEADER.DOCUMENT-TYPE' | translate }}">{{enterprise.documentType ? 'RUC' : 'OTROS'}}</td>
          <td title="{{'TABLE.HEADER.DOCUMENT-NUMBER' | translate }}">{{enterprise.documentNumber}}</td>
          <td title="{{'TABLE.HEADER.ENTERPRISE-NAME' | translate }}">{{enterprise.name}}</td>
          <td title="{{'TABLE.HEADER.BALANCE-IOF' | translate }}"
              *ngIf="showBalanceInfo && hasConfigBalance">{{balance(enterprise)}}</td>
          <td
            title="{{'TABLE.HEADER.STORAGE' | translate }}"><span
            class="{{showLimitStorage(enterprise) ? 'badge badge-iofe-2': ''}}">{{ showLimitStorage(enterprise) }}</span>
          </td>
          <td title="{{'TABLE.HEADER.DATE-AT' | translate }}">{{enterprise.createAt | dateformat}}</td>
          <td title="{{'TABLE.HEADER.STATE' | translate }}"><span
            class="{{!enterprise.active? 'badge badge-danger':''}}">{{enterprise.active ? ('TABLE.HEADER.ACTIVE' | translate) : ('TABLE.HEADER.INACTIVE' | translate)}}</span>
          </td>
          <td title="{{'TABLE.HEADER.ACTION' | translate }}">
            <button type="button" class="btn btn-default" *ngIf="!isAllowedEdit(enterprise)">
              <i class="fa fa-ellipsis-va"></i>
            </button>
            <div class="dropdown dropcenter" *ngIf="isAllowedEdit(enterprise)">
              <button type="button" class="btn btn-default " id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu" data-bs-toggle="dropdown"
                   aria-labelledby="dropdownMenuButton">
                <button class="dropdown-item cursor-hover" *ngIf="customLinkIsPresent(enterprise)"
                        (click)="copyToClipboard(enterprise)">
                  <i class="fa fa-copy"></i> {{ "BUTTON.COPY-URL" | translate }}
                </button>
                <button class="dropdown-item cursor-hover"
                        *ngIf="hasAuthority('own:enterprise:edit') && isAllowedEdit(enterprise)"
                        (click)="openModalEdit(enterprise)">
                  <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
                </button>
                <button class="dropdown-item  cursor-hover"
                        (click)="openModalAssignBalance(enterprise)"
                        *ngIf="showBalanceInfo && ((hasRole(ROLE_SUPERADMIN) && isPartner(enterprise) && enterprise.isCustomer) || (hasRole(ROLE_PARTNER) && hasAuthority('own:enterprise:add:balance') && isntPartner(enterprise) && enterprise.isCustomer && hasConfigBalance))">
                  <i class="fa fa-coins"></i> {{ "BUTTON.ASSIGN-BALANCE" | translate }}
                </button>
                <button class="dropdown-item cursor-hover"
                        (click)="openModalViewHistoricalBalance(enterprise)"
                        *ngIf="showBalanceInfo && (enterprise.isCustomer && isAllowedEdit(enterprise) && !hasRole(ROLE_ADMIN) && hasConfigBalance)">
                  <i class="fa fa-route icon-color-green"></i> {{ "BUTTON.VIEW-BALANCE-HISTORY" | translate }}
                </button>
                <button class="dropdown-item cursor-hover"
                        *ngIf="hasAuthority('own:enterprise:delete') && isAllowedEdit(enterprise)"
                        (click)="delete(enterprise)">
                  <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
                </button>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <nav class="Page navigation pagination-custom">
      <div class="row">
        <div class="col-md-8 mt-1">
          <div class="justify-content-row">
            <label class="mr-1 font-weight-normal">Mostrar </label>
            <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                    (ngModelChange)="reloadEnterprises()">
              <option *ngFor="let page of pageNumbers" [value]="page.value"
                      class="font-weight-bold">{{page.value}}</option>
            </select>
            <label class="font-weight-normal"> registros.</label>
          </div>
          <div class="page-total-entries">
            {{ "LABEL.TOTAL-RECORDS" | translate }}
            : {{enterprises.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
          </div>
        </div>
        <div class="col-md-4">
          <ul class="pagination justify-content-end text-center">
            <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
              <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="getEnterprises(enumPage.First)"
                 tabindex="-1" aria-disabled="true">
                <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
                {{ "BUTTON.FIRST" | translate }}
              </a>
            </li>
            <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
              <a class="left {{page.number == 0 ? 'disabled' : ''}}" (click)="getEnterprises(enumPage.Previous)">
                <i class="fa fa-angle-left" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="right" (click)="getEnterprises(enumPage.Next)"><i
                class="fa fa-angle-right" aria-hidden="true"></i></a>
            </li>
            <li
              class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
              <a class="next" (click)="getEnterprises(enumPage.Last)">
                {{ "BUTTON.LAST" | translate }}
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
